import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import About from '../components/About';
import Download from '../components/Download';
import AboutApp from '../components/AboutApp';
import Team from '../components/Team';
import HowItWorks from '../components/HowItWorks';
import NeuralFlow from '../components/NeuralFlow';
import Pricing from '../components/pricing';
import Reviews from '../components/Reviews';
import Cosmic3DModel from '../components/CosmicModel3d';



const Home = () => (
  <>
    <Hero />
    <Features />
    <AboutApp />
    <HowItWorks />
    <NeuralFlow/>
    <Reviews />
    <Pricing />
    <Team />
    <Cosmic3DModel/>
    <Download />
  </>
);

export default Home;